import React, { useState, useRef } from 'react';

// const API_URL    = 'http://10.10.192.254:8060/api/scan';
// const REPORT_URL = 'http://10.10.192.254:8060/api/report';
// // http://62.72.30.241:8081/
// const MIN_LOAD_MS = 5000;


const API_URL    = 'https://qucheck.redrubytechnologies.com:8081/api/scan';
const REPORT_URL = 'https://qucheck.redrubytechnologies.com:8081/api/report';
// http://62.72.30.241:8081/
const MIN_LOAD_MS = 5000;

const STEPS = [
  'Resolving domain & establishing TLS handshake…',
  'Inspecting certificate chain & issuer…',
  'Analysing cryptographic key algorithms…',
  'Assessing quantum vulnerability exposure…',
  'Generating security report…',
];

const STEP_MS = MIN_LOAD_MS / STEPS.length;

const DOMAIN_RE = /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
const IP_RE     = /^(\d{1,3}\.){3}\d{1,3}$/;

function isValidTarget(val) {
  return DOMAIN_RE.test(val) || IP_RE.test(val);
}

export default function QuantomeScan() {
  const [domain, setDomain] = useState('');
  const [phase, setPhase] = useState('idle'); // idle | loading | done | error
  const [result, setResult] = useState(null);
  const [completedSteps, setCompletedSteps] = useState(0); // 0-5 steps done
  const [errMsg, setErrMsg] = useState('');
  const [inputErr, setInputErr] = useState('');
  const [emailOpen, setEmailOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const resultsRef = useRef(null);

  const scan = async (e) => {
    e.preventDefault();
    const t = domain.trim().replace(/^https?:\/\//i, '').replace(/\/.*/, '');
    if (!t) return;

    if (!isValidTarget(t)) {
      setInputErr('Enter a valid domain (e.g. example.com) or IP address (e.g. 93.184.216.34)');
      return;
    }
    setInputErr('');

    setPhase('loading');
    setResult(null);
    setErrMsg('');
    setCompletedSteps(0);
    setSent(false);

    // advance one step every STEP_MS
    let stepCount = 0;
    const stepTimer = setInterval(() => {
      stepCount += 1;
      setCompletedSteps(stepCount);
      if (stepCount >= STEPS.length) clearInterval(stepTimer);
    }, STEP_MS);

    const minWait = new Promise((res) => setTimeout(res, MIN_LOAD_MS));

    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ target: t }),
      });

      if (!res.ok) throw new Error(`Server responded with ${res.status}`);
      const data = await res.json();

      // show error immediately — no need to wait out the timer
      if (data.ok === false) throw new Error(data.message || 'Scan failed — please try again.');

      // success — honour the minimum loading time
      await minWait;
      clearInterval(stepTimer);
      setCompletedSteps(STEPS.length);

      setResult(data);
      setPhase('done');
      setTimeout(() => {
        if (resultsRef.current) {
          const top = resultsRef.current.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 120);
    } catch (err) {
      clearInterval(stepTimer);
      setErrMsg(err.message || 'Scan failed — please try again.');
      setPhase('error');
    }
  };

  const reset = () => {
    setPhase('idle');
    setResult(null);
    setDomain('');
    setSent(false);
    setCompletedSteps(0);
    setInputErr('');
  };

  const sendEmail = async () => {
    if (!email.trim()) return;
    setSending(true);
    try {
      const res = await fetch(REPORT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), scan_result: result }),
      });
      const data = await res.json();
      if (data.ok === false) throw new Error(data.message || 'Failed to send report.');
    } catch (err) {
      setSending(false);
      setErrMsg(err.message || 'Failed to send report — please try again.');
      setEmailOpen(false);
      return;
    }
    setSending(false);
    setSent(true);
  };

  /* derived — API wraps data under result.analysis */
  const a       = result?.analysis ?? {};
  const safe    = a.quantum_safe === true || a.status === 'Fully Protected' ||
                  (typeof a.quantum_safe === 'string' && a.quantum_safe.toLowerCase().includes('safe') && !a.quantum_safe.toLowerCase().includes('not') && !a.quantum_safe.toLowerCase().includes('partial'));
  const expired = a.is_expired === true;
  const partial = !safe && typeof a.quantum_safe === 'string' && a.quantum_safe.toLowerCase().includes('partial');
  const days    = a.days_remaining ?? null;

  // red = expired or At Risk, yellow = Partial, green = Fully Protected
  const statusColor  = expired || (!safe && !partial) ? '#dc2626' : partial ? '#d97706' : '#16a34a';
  const statusBg     = expired || (!safe && !partial)
    ? 'linear-gradient(135deg,#fef2f2,#fee2e2)'
    : partial
    ? 'linear-gradient(135deg,#fffbeb,#fef3c7)'
    : 'linear-gradient(135deg,#f0fdf4,#dcfce7)';
  const statusBorder = expired || (!safe && !partial) ? '#fca5a5' : partial ? '#fcd34d' : '#86efac';
  const statusLabel  = expired ? 'Certificate Expired' : (a.status || (safe ? 'Fully Protected' : partial ? 'Partially Quantum-Safe' : 'At Risk'));
  const statusIcon   = expired || (!safe && !partial) ? 'fa-times-circle' : partial ? 'fa-exclamation-triangle' : 'fa-check-circle';

  const progress = (completedSteps / STEPS.length) * 100;

  return (
    <div style={S.page}>

      {/* ═══════════ FORM CARD ═══════════ */}
      <div style={S.formWrap}>
        <form onSubmit={scan} style={S.formCard}>
          <div style={S.inputRow} className="qscan-row">
            <div style={S.inputWrap}>
              <i className="fa fa-globe" style={S.globeIcon} />
              <input
                type="text"
                value={domain}
                onChange={(e) => {
                  setDomain(e.target.value);
                  setInputErr('');
                  if (phase === 'done' || phase === 'error') {
                    setPhase('idle');
                    setResult(null);
                    setErrMsg('');
                  }
                }}
                placeholder="yourdomain.com"
                style={S.input}
                disabled={phase === 'loading'}
                autoComplete="off"
                spellCheck="false"
              />
            </div>
            <button
              type="submit"
              className="qscan-btn"
              style={{ ...S.scanBtn, opacity: (phase === 'loading' || !domain.trim()) ? 0.6 : 1 }}
              disabled={phase === 'loading' || !domain.trim()}
            >
              {phase === 'loading'
                ? <><span style={S.spinnerEl} />Scanning…</>
                : <><i className="fa fa-search" style={{ marginRight: 8 }} />Check Now</>}
            </button>
          </div>

          {inputErr && (
            <div style={S.inputErrMsg}>
              <i className="fa fa-exclamation-circle" style={{ marginRight: 6 }} />
              {inputErr}
            </div>
          )}

          {phase === 'idle' && !inputErr && (
            <div style={S.examples}>
              <span style={S.exLabel}>Try:</span>
              {['google.com', 'github.com', 'microsoft.com'].map((d) => (
                <button key={d} type="button" style={S.exChip} onClick={() => setDomain(d)}>{d}</button>
              ))}
            </div>
          )}
        </form>
      </div>

      {/* ═══════════ LOADING — 5-step progress ═══════════ */}
      {phase === 'loading' && (
        <div style={S.loadWrap}>
          {/* progress bar */}
          <div style={S.barTrackOuter}>
            <div style={{ ...S.barFillOuter, width: `${progress}%` }} />
          </div>
          <p style={S.progressPct}>{Math.round(progress)}%</p>

          {/* step list */}
          <div style={S.stepList}>
            {STEPS.map((label, i) => {
              const done    = i < completedSteps;
              const active  = i === completedSteps;
              return (
                <div key={label} style={S.stepRow}>
                  <div style={{
                    ...S.stepCircle,
                    background: done ? '#16a34a' : active ? '#3b82f6' : '#e2e8f0',
                    border: active ? '2px solid #3b82f6' : 'none',
                  }}>
                    {done
                      ? <i className="fa fa-check" style={{ color: '#fff', fontSize: 11 }} />
                      : active
                      ? <span style={S.activeDot} />
                      : <span style={{ color: '#94a3b8', fontSize: 11, fontWeight: 700 }}>{i + 1}</span>
                    }
                  </div>
                  <span style={{
                    ...S.stepLabel,
                    color: done ? '#16a34a' : active ? '#1e40af' : '#94a3b8',
                    fontWeight: done || active ? 600 : 400,
                  }}>
                    {label}
                  </span>
                  {active && (
                    <span style={S.stepSpinner} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ═══════════ ERROR ═══════════ */}
      {phase === 'error' && (
        <div style={S.errBox}>
          <i className="fa fa-exclamation-circle" style={{ color: '#dc2626', fontSize: 20 }} />
          <span style={{ flex: 1 }}>{errMsg}</span>
          <button style={S.retryBtn} onClick={reset}>Try Again</button>
        </div>
      )}

      {/* ═══════════ RESULTS ═══════════ */}
      {phase === 'done' && result && (
        <div ref={resultsRef} style={S.results}>

          {/* STATUS BANNER */}
          <div className="qstatus-card" style={{ ...S.statusCard, background: statusBg, border: `1.5px solid ${statusBorder}` }}>
            <div style={S.statusLeft}>
              <i className={`fa ${statusIcon}`} style={{ fontSize: 44, color: statusColor, flexShrink: 0 }} />
              <div>
                <div style={{ ...S.statusLabel, color: statusColor }}>{statusLabel}</div>
                <div style={S.statusDomain}>{result.target || domain}</div>
                {a.current_encryption && (
                  <div style={{ ...S.encBadge, background: safe ? '#dcfce7' : '#fef3c7', color: safe ? '#15803d' : '#92400e', border: `1px solid ${safe ? '#86efac' : '#fcd34d'}` }}>
                    {a.current_encryption}
                  </div>
                )}
              </div>
            </div>
            <div style={S.statusRight}>
              {a.downgrade_risk && (
                <div style={S.downgradeTag}>
                  <i className="fa fa-exclamation-triangle" style={{ marginRight: 5, fontSize: 11 }} />
                  Downgrade Risk
                </div>
              )}
            </div>
          </div>

          {/* SECURITY OVERVIEW — 4-metric summary */}
          <div style={S.card}>
            <div style={S.cardHead}>
              <i className="fa fa-bar-chart" style={S.cardHeadIcon} />
              Security Overview
            </div>
            <div style={S.metricsGrid} className="qscan-metrics">
              {[
                {
                  label: 'Quantum Resistant',
                  val: a.quantum_resistant || (safe ? 'Yes' : 'No'),
                  icon: safe ? 'fa-check-circle' : 'fa-times-circle',
                  ok: safe,
                },
                {
                  label: 'PQC Algorithm',
                  val: a.pqc_algorithm && a.pqc_algorithm !== 'None' ? a.pqc_algorithm : 'None',
                  icon: 'fa-crosshairs',
                  ok: a.pqc_algorithm && a.pqc_algorithm !== 'None',
                },
                {
                  label: 'Downgrade Risk',
                  val: a.downgrade_risk ? 'Detected' : 'None',
                  icon: a.downgrade_risk ? 'fa-exclamation-triangle' : 'fa-check-circle',
                  ok: !a.downgrade_risk,
                },
                {
                  label: 'Status',
                  val: a.status || (safe ? 'Fully Protected' : 'At Risk'),
                  icon: safe ? 'fa-check-circle' : 'fa-times-circle',
                  ok: safe,
                },
              ].map(({ label, val, icon, ok }) => (
                <div key={label} style={S.metricItem}>
                  <div style={{ ...S.metricIcon, background: ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${ok ? '#86efac' : '#fca5a5'}` }}>
                    <i className={`fa ${icon}`} style={{ color: ok ? '#16a34a' : '#dc2626', fontSize: 18 }} />
                  </div>
                  <div style={S.metricLabel}>{label}</div>
                  <div style={{ ...S.metricVal, color: ok ? '#15803d' : '#dc2626' }}>{val}</div>
                </div>
              ))}
            </div>
          </div>

          {/* AT RISK — red */}
          {!safe && !partial && !expired && (
            <div style={{ ...S.alertBox, background: '#fef2f2', border: '1px solid #fca5a5' }}>
              <i className="fa fa-times-circle" style={{ color: '#dc2626', flexShrink: 0, marginTop: 2, fontSize: 16 }} />
              <div>
                <strong style={{ color: '#991b1b' }}>Quantum Risk Detected</strong>
                <p style={{ margin: '4px 0 0', color: '#7f1d1d', fontSize: 13.5, lineHeight: 1.6 }}>
                  {a.vulnerability_detail ||
                    `This certificate uses ${a.key_type || 'RSA/ECDSA'} cryptography which is vulnerable to Shor's Algorithm on a sufficiently powerful quantum computer.`}
                </p>
              </div>
            </div>
          )}

          {/* PARTIAL — yellow */}
          {partial && !expired && (
            <div style={S.alertBox}>
              <i className="fa fa-exclamation-triangle" style={{ color: '#d97706', flexShrink: 0, marginTop: 2, fontSize: 16 }} />
              <div>
                <strong style={{ color: '#92400e' }}>Partially Quantum-Safe</strong>
                <p style={{ margin: '4px 0 0', color: '#78350f', fontSize: 13.5, lineHeight: 1.6 }}>
                  {a.vulnerability_detail ||
                    `This certificate has partial quantum protection. Key exchange may be secured but the signature algorithm remains classically vulnerable.`}
                </p>
              </div>
            </div>
          )}

          {/* SAFE — green */}
          {safe && !expired && (
            <div style={S.safeBox}>
              <i className="fa fa-check-circle" style={{ color: '#16a34a', fontSize: 18, flexShrink: 0, marginTop: 2 }} />
              <div>
                <strong style={{ color: '#15803d' }}>Post-Quantum Hybrid Active</strong>
                <p style={{ margin: '4px 0 0', color: '#166534', fontSize: 13.5, lineHeight: 1.6 }}>
                  {a.pqc_algorithm && a.pqc_algorithm !== 'None'
                    ? `This domain uses ${a.pqc_algorithm} — a hybrid post-quantum key exchange that resists Shor's Algorithm. Continue monitoring as NIST PQC standards evolve.`
                    : 'This domain uses algorithms not immediately vulnerable to known quantum attacks. Continue monitoring as NIST PQC standards are adopted industry-wide.'}
                </p>
              </div>
            </div>
          )}

          {/* CERTIFICATE HEALTH */}
          <div style={S.card}>
            <div style={S.cardHead}>
              <i className="fa fa-certificate" style={S.cardHeadIcon} />
              Certificate Health
            </div>
            <div style={S.cardBody}>
              {[
                { icon: 'fa-user',       label: 'Subject CN',          val: a.subject_cn        },
                { icon: 'fa-building',   label: 'Issuer',              val: a.issuer            },
                { icon: 'fa-calendar',   label: 'Valid From',          val: a.not_before        },
                { icon: 'fa-calendar-o', label: 'Expires On',          val: a.not_after         },
                { icon: 'fa-key',        label: 'Key Type',            val: a.key_type          },
                { icon: 'fa-lock',       label: 'Key Size',            val: a.key_size          },
                { icon: 'fa-pencil',     label: 'Signature Algorithm', val: a.signature_algorithm },
              ].map(({ icon, label, val }) => val ? (
                <div key={label} style={S.infoRow}>
                  <span style={S.infoLabel}>
                    <i className={`fa ${icon}`} style={S.rowIcon} />
                    {label}
                  </span>
                  <span style={S.infoVal}>{val}</span>
                </div>
              ) : null)}

              {a.sans && a.sans.length > 0 && (
                <div style={S.infoRow}>
                  <span style={S.infoLabel}>
                    <i className="fa fa-list" style={S.rowIcon} />
                    SANs
                  </span>
                  <span style={{ display: 'flex', flexWrap: 'wrap', gap: 5, justifyContent: 'flex-end' }}>
                    {a.sans.map((s) => (
                      <span key={s} style={S.chip}>{s}</span>
                    ))}
                  </span>
                </div>
              )}

              {days !== null && (
                <div style={{ marginTop: 14 }}>
                  <div style={S.barMeta}>
                    <span>Certificate Lifetime</span>
                    <span style={{ color: days < 30 ? '#dc2626' : '#16a34a', fontWeight: 700 }}>
                      {days < 0 ? 'Expired' : `${days} days remaining`}
                    </span>
                  </div>
                  <div style={S.certBarTrack}>
                    <div style={{
                      ...S.certBarFill,
                      width: `${Math.max(2, Math.min(100, (days / 365) * 100))}%`,
                      background: days < 30 ? '#dc2626' : days < 90 ? '#f59e0b' : '#16a34a',
                    }} />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* ACTIONS */}
          <div style={S.actionsRow}>
            <button style={S.btnSecondary} onClick={() => { setEmail(''); setSent(false); setEmailOpen(true); }}>
              <i className="fa fa-envelope" style={{ marginRight: 8 }} />
              Email Full Report
            </button>
            <button style={S.btnGhost} onClick={reset}>
              <i className="fa fa-refresh" style={{ marginRight: 8 }} />
              Check Another Domain
            </button>
          </div>

        </div>
      )}

      {/* ═══════════ CTA BANNER — always visible ═══════════ */}
      <div className="qcta-wrap-outer" style={{ ...S.ctaWrap, marginTop: 40 }}>
        <div className="qcta-box" style={S.ctaBox}>
          <div style={S.ctaGlow} />
          <div style={S.ctaGlow2} />

          {/* LEFT — text */}
          <div style={S.ctaLeft}>
            <h3 style={S.ctaTitle}>Secure All Your Digital Assets</h3>
            <p style={S.ctaDesc}>
              Our security engineers provide hands-on post-quantum migration, full
              certificate audits, and ongoing quantum-readiness monitoring across
              your entire organisation.
            </p>
            <div style={S.ctaFeatGrid} className="qcta-feat-grid">
              {[
                { icon: 'fa-search', text: 'Full infrastructure quantum audit' },
                { icon: 'fa-lock',   text: 'PQC certificate migration support' },
                { icon: 'fa-bell',   text: 'Continuous monitoring & alerts'    },
                { icon: 'fa-file',   text: 'NIST compliance reporting'         },
              ].map((f) => (
                <div key={f.text} style={S.ctaFeatItem}>
                  <div style={S.ctaFeatIcon}>
                    <i className={`fa ${f.icon}`} style={{ color: '#60a5fa', fontSize: 13 }} />
                  </div>
                  <span style={{ color: '#e0f2fe', fontSize: 13.5 }}>{f.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — action panel */}
          <div style={S.ctaRight} className="qcta-right">
            <div style={S.ctaShieldWrap}>
              <i className="fa fa-shield" style={S.ctaShieldIcon} />
            </div>
            <div style={S.ctaRightText}>Ready to go quantum-safe?</div>
            <a href="/#footers" style={S.ctaBtn}>
              <i className="fa fa-arrow-right" style={{ marginRight: 10 }} />
              Connect With Our Team
            </a>
          </div>

        </div>
      </div>

      {/* ═══════════ EMAIL MODAL ═══════════ */}
      {emailOpen && (
        <div style={S.modalOverlay} onClick={() => setEmailOpen(false)}>
          <div style={S.modalBox} onClick={(e) => e.stopPropagation()}>

            {/* header */}
            <div style={S.modalHead}>
              <div style={S.modalIconWrap}>
                <i className="fa fa-envelope" style={{ color: '#fff', fontSize: 20 }} />
              </div>
              <div>
                <div style={S.modalTitle}>Email Full Report</div>
                <div style={S.modalSub}>
                  Quantum security report for <strong style={{ color: '#1e40af' }}>{result?.target || domain}</strong>
                </div>
              </div>
              <button style={S.modalClose} onClick={() => setEmailOpen(false)}>
                <i className="fa fa-times" />
              </button>
            </div>

            {/* body */}
            <div style={S.modalBody}>
              {sent ? (
                <div style={S.sentWrap}>
                  <div style={S.sentIconWrap}>
                    <i className="fa fa-check" style={{ color: '#fff', fontSize: 24 }} />
                  </div>
                  <div style={S.sentTitle}>Report Sent!</div>
                  <div style={S.sentDesc}>Check your inbox at <strong>{email}</strong></div>
                </div>
              ) : (
                <>
                  <label style={S.inputLabel}>Your Email Address</label>
                  <div style={S.inputWrap2}>
                    {/* <i className="fa fa-envelope-o" style={S.inputIcon2} /> */}
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@example.com"
                      style={S.modalInput}
                      autoFocus
                      onKeyDown={(e) => e.key === 'Enter' && sendEmail()}
                    />
                  </div>
                  <p style={S.modalNote}>
                    We'll send the complete scan result including certificate details, quantum risk assessment, and NIST PQC recommendations.
                  </p>
                </>
              )}
            </div>

            {/* footer */}
            {!sent && (
              <div style={S.modalFooter}>
                <button style={S.modalCancelBtn} onClick={() => setEmailOpen(false)}>
                  Cancel
                </button>
                <button
                  style={{ ...S.modalSendBtn, opacity: (sending || !email.trim()) ? 0.6 : 1 }}
                  onClick={sendEmail}
                  disabled={sending || !email.trim()}
                >
                  {sending
                    ? <><span style={S.spinnerEl} />Sending…</>
                    : <><i className="fa fa-paper-plane" style={{ marginRight: 8 }} />Send Report</>}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin      { to { transform: rotate(360deg); } }
        @keyframes pulse     { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.5;transform:scale(1.4)} }
      `}</style>
    </div>
  );
}

/* ═══════════ STYLES ═══════════ */
const S = {
  page: {
    background: '#f8fafc',
    padding: '0 20px 48px',
    fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif',
  },

  /* form */
  formWrap: { maxWidth: 680, margin: '-40px auto 0', position: 'relative', zIndex: 2 },
  formCard: {
    background: '#fff', borderRadius: 20,
    boxShadow: '0 4px 6px rgba(0,0,0,0.06),0 10px 40px rgba(0,0,0,0.1)',
    padding: '28px 28px 20px',
  },
  inputRow: { display: 'flex', gap: 12 },
  inputWrap: { position: 'relative', flex: 1 },
  globeIcon: {
    position: 'absolute', left: 14, top: '50%',
    transform: 'translateY(-50%)', color: '#94a3b8', fontSize: 16, zIndex: 1,
  },
  input: {
    width: '100%', boxSizing: 'border-box',
    border: '1.5px solid #e2e8f0', borderRadius: 12,
    padding: '14px 14px 14px 44px', fontSize: 16,
    color: '#1e293b', outline: 'none',
    fontFamily: 'inherit',
  },
  scanBtn: {
    background: 'linear-gradient(135deg,#1e40af 0%,#3b82f6 100%)',
    color: '#fff', border: 'none', borderRadius: 12,
    padding: '0 26px', fontSize: 15, fontWeight: 700, cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
    fontFamily: 'inherit',
  },
  spinnerEl: {
    display: 'inline-block', width: 14, height: 14,
    border: '2px solid rgba(255,255,255,0.35)',
    borderTopColor: '#fff', borderRadius: '50%',
    animation: 'spin 0.7s linear infinite', marginRight: 6,
  },
  examples: { marginTop: 14, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
  inputErrMsg: {
    marginTop: 10, padding: '8px 12px',
    background: '#fef2f2', border: '1px solid #fca5a5',
    borderRadius: 8, color: '#dc2626',
    fontSize: 13, display: 'flex', alignItems: 'center',
  },
  exLabel: { fontSize: 13, color: '#94a3b8' },
  exChip: {
    background: 'none', border: '1px solid #e2e8f0',
    borderRadius: 6, padding: '3px 12px',
    color: '#3b82f6', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
  },

  /* loading */
  loadWrap: {
    maxWidth: 520, margin: '40px auto 0',
    background: '#fff', borderRadius: 20,
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    padding: '32px 36px',
  },
  barTrackOuter: {
    height: 8, background: '#e2e8f0', borderRadius: 4,
    overflow: 'hidden', marginBottom: 8,
  },
  barFillOuter: {
    height: '100%', borderRadius: 4,
    background: 'linear-gradient(90deg,#1e40af,#3b82f6)',
    transition: 'width 0.9s ease',
  },
  progressPct: {
    textAlign: 'right', fontSize: 12, fontWeight: 700,
    color: '#3b82f6', margin: '0 0 24px',
  },
  stepList: { display: 'flex', flexDirection: 'column', gap: 14 },
  stepRow: { display: 'flex', alignItems: 'center', gap: 12 },
  stepCircle: {
    width: 28, height: 28, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0, transition: 'background 0.3s',
  },
  activeDot: {
    width: 8, height: 8, borderRadius: '50%',
    background: '#fff', animation: 'pulse 1s ease-in-out infinite',
    display: 'inline-block',
  },
  stepLabel: { fontSize: 14, lineHeight: 1.4, flex: 1, transition: 'color 0.3s' },
  stepSpinner: {
    display: 'inline-block', width: 14, height: 14, flexShrink: 0,
    border: '2px solid #bfdbfe', borderTopColor: '#3b82f6',
    borderRadius: '50%', animation: 'spin 0.7s linear infinite',
  },

  /* error */
  errBox: {
    maxWidth: 640, margin: '28px auto',
    background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 12,
    padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 12, color: '#dc2626',
  },
  retryBtn: {
    marginLeft: 'auto', background: '#dc2626', color: '#fff',
    border: 'none', borderRadius: 8, padding: '7px 18px',
    cursor: 'pointer', fontWeight: 700, fontSize: 13, fontFamily: 'inherit',
  },

  /* results */
  results: {
    maxWidth: 680, margin: '36px auto 0',
    display: 'flex', flexDirection: 'column', gap: 20,
  },

  /* status banner */
  statusCard: {
    borderRadius: 16, padding: '24px 28px',
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', flexWrap: 'wrap', gap: 16,
  },
  statusLeft:  { display: 'flex', alignItems: 'center', gap: 16, flex: 1, minWidth: 0 },
  statusRight: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8, flexShrink: 0 },
  statusLabel: { fontSize: 22, fontWeight: 800, lineHeight: 1.2 },
  statusDomain: { fontSize: 13.5, color: '#64748b', marginTop: 4, fontFamily: 'monospace' },
  encBadge: {
    display: 'inline-block', marginTop: 6,
    borderRadius: 6, padding: '3px 10px',
    fontSize: 11.5, fontWeight: 700, letterSpacing: 0.3,
  },
  daysBadge: {
    borderRadius: 20, padding: '8px 16px',
    fontSize: 13, fontWeight: 700,
    display: 'inline-flex', alignItems: 'center',
  },
  downgradeTag: {
    borderRadius: 20, padding: '6px 12px',
    fontSize: 12, fontWeight: 700,
    display: 'inline-flex', alignItems: 'center',
    background: '#fef2f2', color: '#dc2626', border: '1px solid #fca5a5',
  },
  chip: {
    display: 'inline-block', borderRadius: 6,
    padding: '2px 8px', fontSize: 12, fontWeight: 600,
    background: '#eff6ff', color: '#1e40af', border: '1px solid #bfdbfe',
  },

  /* alert / safe */
  alertBox: {
    background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 12,
    padding: '14px 18px', display: 'flex', gap: 12, alignItems: 'flex-start',
  },
  safeBox: {
    background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 12,
    padding: '14px 18px', display: 'flex', gap: 12, alignItems: 'flex-start',
  },

  /* security overview metrics */
  metricsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 0,
    padding: '4px 0',
  },
  metricItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '18px 10px',
    borderRight: '1px solid #f1f5f9',
  },
  metricIcon: {
    width: 44, height: 44, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    marginBottom: 10, flexShrink: 0,
  },
  metricLabel: {
    fontSize: 11.5, color: '#94a3b8',
    fontWeight: 600, textTransform: 'uppercase',
    letterSpacing: 0.4, marginBottom: 5,
  },
  metricVal: {
    fontSize: 13.5, fontWeight: 700,
    lineHeight: 1.3, wordBreak: 'break-word',
  },

  /* certificate health card */
  card: {
    background: '#fff', borderRadius: 16,
    boxShadow: '0 1px 3px rgba(0,0,0,0.05),0 4px 16px rgba(0,0,0,0.07)',
    overflow: 'hidden',
  },
  cardHead: {
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '15px 20px', borderBottom: '1px solid #f1f5f9',
    fontWeight: 700, fontSize: 14.5, color: '#1e293b',
  },
  cardHeadIcon: { color: '#3b82f6', fontSize: 14 },
  cardBody: { padding: '16px 20px' },
  infoRow: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    padding: '8px 0', borderBottom: '1px solid #f8fafc', gap: 12,
  },
  infoLabel: { color: '#64748b', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 },
  infoVal:   { color: '#1e293b', fontSize: 13, fontWeight: 500, textAlign: 'right', wordBreak: 'break-all' },
  rowIcon:   { color: '#94a3b8', fontSize: 10 },
  barMeta:      { display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#64748b', marginBottom: 6 },
  certBarTrack: { height: 6, background: '#e2e8f0', borderRadius: 3, overflow: 'hidden' },
  certBarFill:  { height: '100%', borderRadius: 3, transition: 'width 0.6s ease' },

  /* CTA banner */
  ctaWrap: {
    width: '100vw', position: 'relative',
    left: '50%', right: '50%',
    marginLeft: '-50vw', marginRight: '-50vw',
    padding: '0 40px', boxSizing: 'border-box',
  },
  ctaBox: {
    position: 'relative',
    background: 'linear-gradient(135deg,#0f1f6e 0%,#1e3a8a 55%,#1e40af 100%)',
    borderRadius: 24,
    padding: '52px 60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 48,
    overflow: 'hidden',
    width: '90%',
    maxWidth: '90%',
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  ctaGlow: {
    position: 'absolute', top: -80, left: '30%',
    width: 320, height: 320, borderRadius: '50%',
    background: 'rgba(96,165,250,0.1)',
    pointerEvents: 'none',
  },
  ctaGlow2: {
    position: 'absolute', bottom: -80, right: '15%',
    width: 260, height: 260, borderRadius: '50%',
    background: 'rgba(167,139,250,0.1)',
    pointerEvents: 'none',
  },
  ctaLeft: { flex: '1 1 0', minWidth: 0, position: 'relative', zIndex: 1 },
  ctaEyebrow: {
    display: 'inline-flex', alignItems: 'center', gap: 8,
    background: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: 20, padding: '5px 14px',
    color: '#93c5fd', fontSize: 12, fontWeight: 600,
    marginBottom: 16, letterSpacing: 0.4,
  },
  ctaDot: {
    width: 6, height: 6, borderRadius: '50%',
    background: '#4ade80', boxShadow: '0 0 6px #4ade80',
    display: 'inline-block', flexShrink: 0,
  },
  ctaTitle: {
    color: '#fff', fontSize: 'clamp(22px,2.5vw,32px)',
    fontWeight: 800, lineHeight: 1.2, margin: '0 0 14px',
  },
  ctaDesc: {
    color: '#93c5fd', fontSize: 15, lineHeight: 1.75,
    margin: '0 0 28px',
  },
  ctaFeatGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px 24px',
  },
  ctaFeatItem: {
    display: 'flex', alignItems: 'center', gap: 10,
  },
  ctaFeatIcon: {
    width: 28, height: 28, borderRadius: 8, flexShrink: 0,
    background: 'rgba(96,165,250,0.15)',
    border: '1px solid rgba(96,165,250,0.25)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  ctaRight: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    gap: 16, position: 'relative', zIndex: 1,
    flexShrink: 0, minWidth: 220,
  },
  ctaShieldWrap: {
    width: 88, height: 88, borderRadius: '50%',
    background: 'rgba(255,255,255,0.08)',
    border: '2px solid rgba(255,255,255,0.15)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    marginBottom: 4,
  },
  ctaShieldIcon: {
    fontSize: 40, color: '#60a5fa',
  },
  ctaRightText: {
    color: '#bfdbfe', fontSize: 14, fontWeight: 600, textAlign: 'center',
  },
  ctaBtn: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    background: '#fff', color: '#1e40af',
    borderRadius: 12, padding: '14px 32px',
    fontWeight: 700, fontSize: 15,
    textDecoration: 'none', whiteSpace: 'nowrap',
    boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
    width: '100%', boxSizing: 'border-box',
  },
  ctaNote: {
    color: 'rgba(255,255,255,0.4)', fontSize: 12, textAlign: 'center',
  },

  /* email modal */
  modalOverlay: {
    position: 'fixed', inset: 0, zIndex: 1000,
    background: 'rgba(15,31,110,0.55)',
    backdropFilter: 'blur(4px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 20,
  },
  modalBox: {
    background: '#fff',
    borderRadius: 20,
    width: '100%',
    maxWidth: 460,
    boxShadow: '0 24px 60px rgba(0,0,0,0.2)',
    overflow: 'hidden',
  },
  modalHead: {
    display: 'flex', alignItems: 'center', gap: 14,
    padding: '22px 24px 18px',
    borderBottom: '1px solid #f1f5f9',
  },
  modalIconWrap: {
    width: 44, height: 44, borderRadius: 12, flexShrink: 0,
    background: 'linear-gradient(135deg,#1e40af,#3b82f6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 0,
  },
  modalTitle: {
    fontSize: 17, fontWeight: 800, color: '#0f172a', lineHeight: 1.2,
  },
  modalSub: {
    fontSize: 13, color: '#64748b', marginTop: 3,
  },
  modalClose: {
    marginLeft: 'auto', background: 'none', border: 'none',
    color: '#94a3b8', fontSize: 16, cursor: 'pointer', padding: 4,
    lineHeight: 1, flexShrink: 0,
  },
  modalBody: {
    padding: '20px 24px',
  },
  inputLabel: {
    display: 'block', fontSize: 13, fontWeight: 600,
    color: '#374151', marginBottom: 8,
  },
  inputWrap2: {
    position: 'relative',
    display: 'block',
  },
  inputIcon2: {
    position: 'absolute', left: 14, top: '50%',
    transform: 'translateY(-50%)', color: '#94a3b8', fontSize: 14,
    pointerEvents: 'none', zIndex: 1,
  },
  modalInput: {
    width: '100%', boxSizing: 'border-box',
    border: '1.5px solid #e2e8f0', borderRadius: 10,
    padding: '12px 14px 12px 42px',
    fontSize: 15, color: '#1e293b',
    outline: 'none', fontFamily: 'inherit',
  },
  modalNote: {
    margin: '12px 0 0', fontSize: 12.5,
    color: '#94a3b8', lineHeight: 1.6,
  },
  sentWrap: {
    textAlign: 'center', padding: '16px 0 8px',
  },
  sentIconWrap: {
    width: 60, height: 60, borderRadius: '50%',
    background: 'linear-gradient(135deg,#16a34a,#4ade80)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    margin: '0 auto 16px',
    boxShadow: '0 4px 16px rgba(22,163,74,0.3)',
  },
  sentTitle: {
    fontSize: 20, fontWeight: 800, color: '#15803d', marginBottom: 6,
  },
  sentDesc: {
    fontSize: 14, color: '#4b5563',
  },
  modalFooter: {
    display: 'flex', gap: 10, justifyContent: 'flex-end',
    padding: '0 24px 22px',
  },
  modalCancelBtn: {
    background: 'none', border: '1.5px solid #e2e8f0',
    borderRadius: 10, padding: '10px 20px',
    fontSize: 14, fontWeight: 600, color: '#64748b',
    cursor: 'pointer', fontFamily: 'inherit',
  },
  modalSendBtn: {
    background: 'linear-gradient(135deg,#1e40af,#3b82f6)',
    border: 'none', borderRadius: 10, padding: '10px 24px',
    fontSize: 14, fontWeight: 700, color: '#fff',
    cursor: 'pointer', fontFamily: 'inherit',
    display: 'flex', alignItems: 'center', gap: 4,
  },

  /* actions */
  actionsRow: { display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center', padding: '4px 0' },
  btnPrimary: {
    background: 'linear-gradient(135deg,#1e40af,#3b82f6)',
    color: '#fff', border: 'none', borderRadius: 10,
    padding: '12px 24px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
  },
  btnSecondary: {
    background: '#fff', color: '#1e40af',
    border: '1.5px solid #bfdbfe', borderRadius: 10,
    padding: '12px 24px', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
  },
  btnGhost: {
    background: 'transparent', color: '#64748b',
    border: '1.5px solid #e2e8f0', borderRadius: 10,
    padding: '12px 24px', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
  },
};
